// 项目管理相关API接口
import request from '@/utils/request'

export function pListPage(params,data) {
    return request({
        url: '/project/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 添加设备
 * @param data
 * @returns {*}
 */
export function pAdd(data) {
    // console.log(data)
    return request({
        url: '/project',
        method: 'post',
        data
    })
}

/**
 * 编辑设备
 * @param data
 * @returns {*}
 */
export function pEdit(data) {
    return request({
        url: '/project',
        method: 'put',
        data
    })
}

/**
 * 删除设备
 * @param id
 * @returns {*}
 */
export function pRemove(id) {
    return request({
        url: '/project/'+id,
        method: 'delete'
    })
}
/**
 * 批量添加设备
 * @param data
 * @param productId
 * @returns {*}
 */
export function deviceAddBatch(data,productId,params) {
    return request({
        url: '/project/save/batch/'+productId,
        method: 'post',
        data,
        params,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * 批量修改部门
 * @param departmentId
 * @param data
 * @returns {*}
 */
export function updateDepBat(departmentId,data) {
    return request({
        url: '/project/'+departmentId,
        method: 'put',
        data
    })
}

/**
 * 设备信息带产品类型
 * @param pid
 * @returns {*}
 */
export function projectInfo(pid) {
    return request({
        url: '/project/info/'+pid,
        method: 'get'
    })
}

/**
 * 清理设备
 * @param pid
 * @returns {*}
 */
export function projectReset(pid){
    return request({
        url: '/project/reset/'+pid,
        method: 'get'
    })
}
/**
 * 根据imei查找设备
 * @param pid
 * @returns {*}
 */
export function projectImei(imei){
    return request({
        url: '/project/imei/'+imei,
        method: 'get'
    })
}
